// Slow editorial marquee (CSS-driven, duplicated track for seamless loop).
export default function Marquee({ items, className = "" }) {
  const track = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-white/10 bg-rp-bg py-6 md:py-8 ${className}`} data-testid="marquee">
      <div className="rp-marquee">
        {track.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="px-8 font-display text-3xl font-light uppercase tracking-tight text-white/90 md:px-12 md:text-5xl">
              {item}
            </span>
            <span className="text-2xl text-rp-accent md:text-4xl">✦</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-rp-bg to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-rp-bg to-transparent" />
    </div>
  );
}
